/* Yoopy (20.10.2026): vysuvaci kosik sa otvori hned po kliknuti na Pridat do kosika,
   nie az po odpovedi servera.
   1) Formulare temy (karticky produktov, produkt, sticky tlacidlo) - obali onSubmitAtcForm z assets/product.js.
   2) Tlacidla s vlastnym pridanim (sekcia Yoopy Novinky, upsell "Odporucame k tomu", advertorial)
      - kosik sa vysunie hned a po pridani sa obsah kosika obnovi.
   3) Tlacidla, ktore kosik otvaraju samy, ale az po odpovedi (balicky, kupte spolu)
      - kosik sa vysunie hned, obsah obnovi povodny kod. */
(function () {
  function openDrawer() {
    var oc = document.querySelector('#offcanvas-cart');
    if (!oc || !window.bootstrap) return false;
    oc.classList.add('loading');
    window.bootstrap.Offcanvas.getOrCreateInstance(oc).show();
    return true;
  }

  // 1) formulare temy
  var orig = window.onSubmitAtcForm;
  if (typeof orig === 'function' && !orig.__yoopyFast) {
    var wrapped = function (form, event) {
      try {
        var btn = form.querySelector('.btn-atc');
        if (!form.hasAttribute('data-ecomify-upsell-modal') && !(btn && btn.closest('.modal'))) openDrawer();
      } catch (e) {}
      return orig(form, event);
    };
    wrapped.__yoopyFast = true;
    window.onSubmitAtcForm = wrapped;
  }

  if (window.__yoopyFastFetch) return;
  window.__yoopyFastFetch = true;
  var pending = 0;
  var REFRESH = '.ynov__btn[data-vid], .ynov__v[data-vid], .yoopy-upsell__btn';
  var OPEN_ONLY = '#bought-together-atc, [onclick*="addBundleContentsToCart"]';

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest(REFRESH);
    if (t && !t.disabled) {
      if (openDrawer()) pending = Date.now();
      return;
    }
    t = e.target.closest(OPEN_ONLY);
    if (t && !t.disabled && t.getAttribute('data-redirect-to-checkout') !== 'true') openDrawer();
  }, true);

  // advertorial (formular s vlastnym odoslanim)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.id && f.id.indexOf('advproform-') === 0) {
      if (openDrawer()) pending = Date.now();
    }
  }, true);

  // 2) po pridani obnov obsah kosika
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (pending && Date.now() - pending < 5000 && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      pending = 0;
      p.then(function (res) {
        try {
          if (typeof window.refreshCartContents === 'function') window.refreshCartContents(res.clone());
        } catch (err) {
          var oc = document.querySelector('#offcanvas-cart');
          if (oc) oc.classList.remove('loading');
        }
      }, function () {
        var oc = document.querySelector('#offcanvas-cart');
        if (oc) oc.classList.remove('loading');
      });
    }
    return p;
  };
})();
